import Vue from 'vue'

const POST_OCR_LOGO = {
	BY_ID: (id, filter) => {
		return Vue.$api.get('/view-post-ocrs/' + id, { params: { filter: filter } })
	},
	LIST: filter => {
		return Vue.$api.get('/view-post-ocrs', { params: { filter: filter } })
	},
	COUNT: where => {
		return Vue.$api.get('/view-post-ocrs/count', { params: where })
	},
}

export default POST_OCR_LOGO
